import React from "react";
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import { fadeUp, Section } from "./shared";

const ROWS = ["See options first", "One-minute form", "Soft-search matching", "Funds in as little as 6h", "Support to funding"];

export const ComparisonSection = () => (
  <Section className="pb-24 sm:pb-32">
    <div className="mx-auto max-w-5xl px-5 sm:px-8">
      <motion.h2 variants={fadeUp} className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight text-center mb-4">
        Why UK SMEs choose us
      </motion.h2>
      <motion.p variants={fadeUp} custom={1} className="text-center text-[#052F24]/55 font-light mb-14">
        See how we compare to traditional banks and brokers.
      </motion.p>

      <motion.div variants={fadeUp} custom={2} className="grid grid-cols-3 rounded-3xl overflow-hidden border border-[#052F24]/10">
        <div className="p-6 sm:p-8 bg-white">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#052F24]/40 mb-8">&nbsp;</p>
          {ROWS.map((r) => (
            <p key={r} className="py-3.5 border-t border-[#052F24]/8 text-sm font-medium text-[#052F24]/70">{r}</p>
          ))}
        </div>
        <div className="p-6 sm:p-8 bg-[#052F24] text-[#F6F5F2]">
          <p className="font-display font-extrabold text-lg mb-6 text-[#DFFF00]">Growth Funds</p>
          {ROWS.map((r) => (
            <p key={r} className="py-3.5 border-t border-[#F6F5F2]/15 flex justify-center">
              <Check size={20} className="text-[#DFFF00]" />
            </p>
          ))}
        </div>
        <div className="p-6 sm:p-8 bg-white">
          <p className="font-display font-extrabold text-lg mb-6 text-[#052F24]/40">Banks & brokers</p>
          {ROWS.map((r) => (
            <p key={r} className="py-3.5 border-t border-[#052F24]/8 flex justify-center">
              <X size={20} className="text-[#052F24]/25" />
            </p>
          ))}
        </div>
      </motion.div>
    </div>
  </Section>
);
